import { ErrorHandler, Injectable } from '@angular/core';
import { StudentService } from './services/student.service';
import { StatsService } from './services/stats.service';

import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class AppErrorHandler implements ErrorHandler {
  constructor(
    private studentService: StudentService,
    private statsService: StatsService
  ) {}

  handleError(error) {
    console.error('[AppErrorHandler]', error?.originalError || error);
    this.reportToSentry(error).catch((e) => console.error('[AppErrorHandler] Failed to report to Sentry:', e));
  }

  private async reportToSentry(error: any) {
    try {
      const student = this.studentService.student;
      const statsContext = !!student
        ? student.status !== 'guest'
          ? await this.statsService.processUser()
          : null
        : null;
      const context = {
        id: !!student ? student.remoteId : 'guest',
        ...statsContext,
      };
      this.sendToSentry(error, context);
    } catch {
      const student = this.studentService.student;
      this.sendToSentry(error, { id: !!student ? student.remoteId : 'guest' });
    }
  }

  private sendToSentry(error: any, context: any) {
    Sentry.withScope(function (scope: any) {
      scope.setUser(context);
      Sentry.captureException(error.originalError || error);
    });
  }
}
